import { forwardRef } from 'react';

import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';

import { Calendar } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const DateInputComp = forwardRef(({ value, onClick, customInputProps = {} }, ref) => {
  const formattedDate = value ? format(new Date(value), 'MMM dd, yyyy') : 'Select Date';

  return (
    <Flex
      alignItems="center"
      cursor="pointer"
      py="10px"
      style={{ borderBottom: '1px dashed #999999' }}
      w="max-content"
      onClick={onClick}
      justifyContent="space-between"
      {...customInputProps}
    >
      <TextBodyMedium mr={2} pr={8}>
        {formattedDate}
      </TextBodyMedium>
      <Calendar boxSize="18px" color="icon.g2" mr={2} />
    </Flex>
  );
});
